import {Component, effect, inject, input, signal} from '@angular/core';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Location, NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {LoRaGateway} from "src/app/infrastructure/moovement-api/models/asset";
import {toGatewayColorClass, toGatewayMessage} from 'src/app/domain/devices/gateway/gateway';
import {MapStateService} from 'src/app/presentation/main-view/map-container/map-container-component';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';
import {GatewayStatusStore} from 'src/app/domain/devices/gateway/gateway-status.store';
import {Router} from '@angular/router';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {randomUuid} from 'src/app/domain/util/uuid/uuid';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-gateway-details',
  imports: [
    GenericButtonComponent,
    GatewaySvgComponent,
    NgClass
  ],
  templateUrl: './gateway-details.component.html',
  styleUrl: './gateway-details.component.css'
})
export class GatewayDetailsComponent {

  id = input.required<string>();

  canBeAltered: boolean = false;
  canBeDeleted: boolean = false;
  gateway = signal<LoRaGateway | undefined>(undefined);
  status = signal<string | undefined>(undefined);
  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');

  private gatewayStore = inject(GatewayStore);
  private gatewayStatusStore = inject(GatewayStatusStore);
  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);
  private router = inject(Router);
  private userStore = inject(UserStore);

  constructor(
    private dataSubscriptionService: DataSubscriptionService,
    private dataSynchronisationService: DataSynchronisationService,
    private mapStateService: MapStateService,
    protected viewportService: ViewportService
  ) {
    effect(() => {
      this.gateway.set(this.gatewayStore.entityMap()[this.id()]);
      this.dataSubscriptionService.publish(this.id() + '.focus', randomUuid());
    });

    effect(() => {
      this.canBeAltered = this.userStore.canEditPersistable(this.gateway());
      this.canBeDeleted = this.userStore.canDeletePersistable(this.gateway());
    });

    effect(() => {
      const status = this.gatewayStatusStore.entityMap()[this.id()];
      if (!status) return;

      this.status.set(status.normalisedValue);
      this.statusMessage.set(toGatewayMessage(status.normalisedValue, status.instant));
      this.statusMessageColorClass.set(toGatewayColorClass(status.normalisedValue));
    });
  }

  async delete() {
    const gateway = this.gateway();
    if (!gateway) return;

    if (confirm(`Are you sure you want to delete LoRa gateway '${gateway.name}'?`)) {
      this.dataSynchronisationService.deleteGateway(gateway);
      this.mapStateService.removeLocator();
      this.router.navigate(['/main/information-center']);
    }
  }

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  toggleCustomize(url: string): void {
    if (this.canBeAltered) {
      this.router.navigate([url, this.id()]);
    }
  }
}
